import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { rem, TextButtonLinkSeeAll } from 'design-system';
import GroupsSection from 'features/pay/components/GroupsSection';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
const MAX_GROUPS_IN_FEED = 3;
/**
 * Web has no Pay tab, so the feed is where groups live for UK users.
 * Whether the section shows is decided by the feed priority
 * (selectRemoveGroupsFromFeed), not by the remove-pay-tab experience.
 */
const FeedGroupsSection = ({ noMarginBottom }) => {
    const navigation = useMainStackNavigation();
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    const onPressSeeAll = useCallback(() => {
        navigation.navigateDeprecated('GroupsList');
    }, [navigation]);
    return (<GroupsSection maxGroups={MAX_GROUPS_IN_FEED} hideAddButton button={<TextButtonLinkSeeAll onPress={onPressSeeAll}/>} cardViewStyle={[
            styles.container,
            paddingHorizontalStyle,
            !!noMarginBottom && styles.noMarginBottom,
        ]}/>);
};
export default FeedGroupsSection;
const styles = StyleSheet.create({
    container: {
        marginTop: rem(0),
        marginBottom: rem(24),
    },
    noMarginBottom: {
        marginBottom: 0,
    },
});
